/**
 * Progreso de la generación de un tablero a partir de los eventos de
 * agent-runtime (dashboard_engine.py):
 *   designing -> design {title, tiles} -> executing -> tile_done {tile_id, ok}
 *   -> (repairing)
 * Función pura (reducer), como deep-analysis/deepProgress.js.
 */
export const initialDashboardProgress = () => ({
  phase: 'designing',
  label: 'Preparando el tablero…',
  title: '',
  tiles: []
});

const PHASES = { designing: 'designing', design: 'executing', executing: 'executing', tile_done: 'executing', repairing: 'repairing' };

export const reduceDashboardProgress = (state, event) => {
  const current = state || initialDashboardProgress();
  if (!event || !event.stage) return current;
  const next = { ...current, phase: PHASES[event.stage] || current.phase, label: event.label || current.label };
  if (event.stage === 'design') {
    next.title = event.title || '';
    next.tiles = (event.tiles || []).map((tile) => ({ id: tile.id, title: tile.title, type: tile.type, status: 'pending' }));
  }
  if (event.stage === 'tile_done') {
    next.tiles = current.tiles.map((tile) => (tile.id === event.tile_id ? { ...tile, status: event.ok ? 'ok' : 'error' } : tile));
  }
  return next;
};
